// extracted by mini-css-extract-plugin
export default {"qrCodeContainer":"styles_qrCodeContainer__tnkcw","qrcode":"styles_qrcode__QTHku"};